export const PermissionImpersonationRoles = {
  client: 'client',
  talent: 'talent',
  envoy: 'envoy',
} as const;
export type PermissionImpersonationRolesTypes =
  keyof typeof PermissionImpersonationRoles;
export type PermissionImpersonationRolesValuesType =
  (typeof PermissionImpersonationRoles)[PermissionImpersonationRolesTypes];
